import {
    DEPARTMENT_ACCESS,
    IDepartmentList,
    IUserInfoS,
    EPlatformSectionType as SectionType,
    EPlatformTravelType as TravelType,
} from '@umu/umu-types';
import { FilterDialogListType } from './dataflow';

export interface IDepartment {
    parents: IDepartment;
    children?: IDepartment[];
    name: string;
}

export interface IMemberList {
    member_id: string;
    user_info: IUserInfoS;
    department_id: number;
    role: number;
    role_type: string;
    number: string;
    name: string;
    isSelect: boolean;
    isSelected?: boolean;

    id?: string;
    user_name?: string;
    avatar?: string;
}

export interface IMemberListInfo {
    page_info: IPageInfo;
    list: IMemberList[];
    requestId?: Symbol;
}

export interface IListItem {
    type: TravelType;
    id: string;
    isSelected: boolean;
    name: string; // 内容
    avatar?: string;
    oriData?: any;
    isHaveNextLevel?: boolean;
    checkable?: boolean;
    role?: RoleType;
    user_department_path?: string;
    manage_permission?: number;
}

export enum RoleType {
    admin = 2, // 负责人
    ordinary = 1, // 普通
    unknown = 0, // 未知
}

/**
 * @description: 面包屑结构, 根据 support_modules 定的
 * path:
 * href:
 */
export interface IRoute {
    path?: string;
    href?: string;
    name: string;
}

export interface IListProps {
    type: TravelType;
    isFromDrop?: boolean; // 是否下拉选择框
    section: SectionType;
    departmentId?: string;
    expendParams?: {
        [propName: string]: string;
    }; // 接口额外扩展参数
    excludeDepartmentIds?: string; // 排除的部门id，包括其子部门
    isRadio?: boolean;
    source?: string;
    clsName?: string;
    isAllowSelect?: boolean; // 是否展示全选
    isShowMember?: boolean; // 是否展示成员数量
    allSelectText?: string; // 全选展示文案
    limit?: number; // 多选限制
    access?: DEPARTMENT_ACCESS;
    dataRemoveCb?(key: number, item: IListItem): void;
    dataAddCb?(key: number, item: IListItem): void;
    clean?(): void;
    isLoading?: boolean;
    setIsLoading?: (value: boolean) => void;
    defaultSelectedMemberList?: { id: string }[];
    defaultSelectedDepartmentList?: { id: string; exclude_umu_ids: [] }[];
}

export interface IDListRef {
    cleanStateByParent: () => void;
}

export type MemberItemOriData = {};

export type MemberItem = {
    page_info: IPageInfo;
    list: IListItem[];
    type: FilterDialogListType;
};

export type SugMemberListParams = {
    page: number;
    size: number;
    keyword: string;
    department_id: string;
    exclude_resigned_user: number; //  1为过滤离职用户，0不过滤离职用户
};

export interface ISubDepartInfo {
    department_id: string;
    member_count: string;
    department_name: string;
    parent_department_id: string;
    enterprise_show_name?: string;
    managers: IMemberList[];
    child_path: IDepartmentList[];
    parent_path: IDepartmentList[];
    manage_permission?: number;
}
